const en = {
  cta: {
    contactSupport: 'Contact Support',
    downloadLabel: 'Download Label',
    postponeDelivery: 'Postpone Delivery',
    postponePickup: 'Postpone Pick Up',
  },
  language: {
    label: 'Language',
  },
  driverBox: {
    cancelledBooking: 'Cancelled Booking',
    deliveredTo: 'Your order was delivered',
    driver: 'Driver',
    expectedPickup: 'Expected Pick Up: {{date}}',
    internalTransit: 'Internal Transit Between Depots',
    notFound: 'Not Found',
    packageReceivedBy: 'Your package was received by:',
    registered: 'Registered',
    shipmentPostponed: 'Shipment was Postponed',
    yourDriver: 'Your Driver:',
  },
  progress: {
    arrivingSoonLine1: 'Arriving',
    arrivingSoonLine2: 'Soon',
    outForDeliveryLine1: 'Out for',
    outForDeliveryLine2: 'Delivery',
    outForPickupLine1: 'Out for',
    outForPickupLine2: 'Pick Up',
  },
  requirements: {
    acceptAndContinue: 'Accept & Continue',
    accepting: 'Accepting...',
    acceptError: 'Could not accept terms. Please try again.',
    checkboxLabel:
      'I confirm that I have read and understood these requirements.',
    intro:
      'Please confirm that you have read and understood the following requirements:',
    items: [
      'The device must be dismantled and taken down before pickup.',
      'Brackets, feet, and accessories must be removed from the device.',
      'If your device includes a One Connect Box, it must be sent together with the product and One Connect Cable.',
      'Our driver cannot handle TVs over 55" alone.',
      'Please ensure your shipping label is printed before the pickup date.',
    ],
    title: 'Before we can collect your device',
  },
  reschedule: {
    calendarDays: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
    calendarMonths: [
      'JANUARY',
      'FEBRUARY',
      'MARCH',
      'APRIL',
      'MAY',
      'JUNE',
      'JULY',
      'AUGUST',
      'SEPTEMBER',
      'OCTOBER',
      'NOVEMBER',
      'DECEMBER',
    ],
    confirmingDate: "We're confirming your new {{mode}} date.",
    delivery: 'delivery',
    deliveryNoDates: 'Delivery date cannot be changed — no dates available.',
    errorBody1:
      'We encountered an unexpected error while processing your request. Your shipment remains scheduled as normal.',
    errorBody2:
      'Please try resubmitting your new date. If the problem persists, our support team can help you manually reschedule.',
    errorTitle: 'Your shipment was not updated.',
    footerConfirmed:
      "Once your new date is confirmed, you'll receive both email and SMS updates with the adjusted pickup or delivery details.",
    footerHeadsUp:
      "Postponing isn't always possible if a driver is already en route to your location.",
    footerHeadsUpLabel: 'Heads up:',
    footerOnceConfirmedLabel: 'Once your new date is confirmed,',
    loadDatesError: 'Could not load available dates. Please try again.',
    loadingDates: 'Loading available {{mode}} dates...',
    pickup: 'pickup',
    pickupNoDates: 'Pickup date cannot be changed — no dates available.',
    previousDate: 'Previous {{mode}} date:',
    retry: 'Retry',
    successMessage: 'Your new shipment date is {{date}}.',
    successMessageWithWindow:
      'Your new shipment date is {{date}}, with a time window of {{window}}.',
    successTitle: 'Your shipment has been updated.',
    timeFrame: 'Time Frame',
    title: 'Reschedule your shipment',
    tryAgain: 'Try again',
    updateShipment: 'Update your Shipment',
    updating: 'Updating your shipment...',
  },
  timeline: {
    arrivedAtDepot: 'Shipment Arrived at Depot',
    arrivedAtDepotDesc: 'We received your order at our depot:',
    arrivingShortly: "We'll be with you shortly!",
    bookingRegistered: 'Your booking is registered into our system.',
    cancelled: 'Your order has been cancelled',
    cancelledOn: 'Your order was cancelled on',
    delivered: 'Your order has been delivered.',
    deliveredAt: 'We delivered your order at',
    departedDepot: 'Shipment Departed our Depot',
    departedDepotDesc: 'Your shipments departed our depot:',
    driverEnRoute: 'Our driver is en route to you.',
    driverEnRouteWithEta: 'Our driver is en route to you. ETA {{eta}}.',
    furtherUpdates: 'Further updates will be available soon.',
    orderCancelled: 'Your order has been cancelled',
    orderDelivered: 'Your order has been delivered.',
    orderPickedUp: 'Your order has been picked up.',
    orderPickedUpTitle: 'Your order has been picked up',
    orderRegisteredOn: 'Your order was Registered on',
    outForDelivery: 'Out for delivery!',
    outForPickup: 'Out for pick up!',
    outForPickupEnRoute: 'Out for pickup! Our drive is en route to you.',
    pickedUpOn: 'Your order was picked up on',
    pickedUpOnAt: 'Your order was Picked Up on',
    receivedAt: 'We received your order at',
    registered: 'Registered',
    shipmentArrivedAtDepot: 'Shipment Arrived at Depot:',
    thereShortly: 'We will be there shortly!',
    at: 'at',
    bookingChanged: 'Your booking has been changed',
    orderPostponedFor: 'Your order was postponed on',
  },
  home: {
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      {
        answer:
          'Enter your tracking number in the search field above to see real-time updates, including the latest status and location. You will also be contacted by the driver when they are near your delivery location.',
        question: 'How do I track my shipment?',
      },
      {
        answer:
          'The estimated delivery date is shown in your tracking details. Deliveries are usually made during standard business hours (9 AM – 6 PM).',
        question: 'When will my shipment arrive?',
      },
      {
        answer:
          'First, double-check the number for typos. If it is correct, your shipment may not have been scanned into the system yet. Please try again later.',
        question: 'My tracking number is not working. What should I do?',
      },
      {
        answer:
          'Yes, you can request to postpone your pickup or delivery using the options on the tracking page or the link provided by SMS. If you have any issues, our support team will be happy to help.',
        question: 'Can I postpone my delivery?',
      },
    ],
    features: {
      live: 'Live status updates',
      map: 'Driver on the map',
      reschedule: 'Postpone delivery',
    },
    searchCta: 'Track shipment',
    searchLabel: 'Tracking number',
    searchPlaceholder: 'Enter tracking number',
    searchTitle: 'Look up your shipment',
    subtitle:
      'Enter your tracking number to view live status updates, driver location, and delivery details.',
    title: 'Track your shipment',
  },
  trackSection: {
    info: 'Details',
    status: 'Status',
  },
  shipmentDetails: {
    addresses: 'Route',
    contentsCount: 'Contents',
    courier: 'Courier',
    eyebrow: 'Details',
    noEvents: 'No events recorded yet.',
    orderHistory: 'Order history',
    orderHistoryHint: '{{count}} events',
    overview: 'Overview',
    pickupDate: 'Pickup date',
    recipient: 'Recipient',
    reference: 'Reference',
    sender: 'Sender',
    title: 'Shipment details',
  },
  notFound: {
    backHome: 'Back to homepage',
    code: '404',
    pageDescription: 'The page you are looking for could not be found.',
    pageTitle: 'Page not found',
    trackingDescription:
      'This tracking number could not be found or is no longer available.',
    trackingTitle: 'Tracking not found',
  },
};

export { en };
